import React, { Component } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';

import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  root: {
    color: 'white',
  },
});

const createInlineFormButton = ({ name, children, form }) =>
  @withStyles(styles)
  class InlineFormButton extends Component {
    static serviceName = 'inlineFormButton';
    static form = form;
    static displayName = `InlineFormButton-${name}`;

    static propTypes = {
      setEditorState: PropTypes.func.isRequired,
      editorState: PropTypes.object.isRequired,
      onOverrideContent: PropTypes.func.isRequired,
    };

    preventDefault(e) {
      e.preventDefault();
    }

    onToggleForm = e => {
      e.preventDefault();
      e.stopPropagation();
      this.props.onOverrideContent(form);
    };

    render() {
      const { theme, classes } = this.props;
      return (
        <div className={classes.root} onMouseDown={this.preventDefault}>
          <IconButton color="inherit" onClick={this.onToggleForm}>
            {children}
          </IconButton>
        </div>
      );
    }
  };

export default createInlineFormButton;
